import React from 'react';

const Dropdown = React.memo(({ options, value, onChange, id, valkey, optkey, disabled = false, emptyoption }) => {
  const handleChange = React.useCallback(
    (e) => {
      onChange(e.target.value);
    },
    [onChange]
  );

  return (
    <form className="flex flex-row items-center mt-2">
      <select
        disabled={disabled}
        value={value}
        onChange={handleChange}
        className={`text-gray-800 bg-white text-sm leading-tight h-6 rounded-full outline-none text-left ${disabled ? 'text-gray-400' : ''}`}
        id={id}
        style={{
          width: 'auto',
          padding: '0',
          margin: '0',
          textAlign: 'left',
          paddingRight: '1.5rem',
          background: `url('data:image/svg+xml;utf8,<svg fill="%23000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>') no-repeat right 0.1rem center`, // Стрелочка сдвинута на 0.5rem вправо
          WebkitAppearance: 'none',
          MozAppearance: 'none',
          appearance: 'none',
          direction: 'rtl',
        }}>
        {options.length === 0 && <option>{emptyoption}</option>}
        {options.map((opt) => {
          return (
            <option key={opt[valkey]} value={opt[valkey]}>
              {opt[optkey]}
            </option>
          );
        })}
      </select>
    </form>
  );
});

export default Dropdown;
